/**
 * Ruta desconocida. Requisito del proyecto: nunca una pantalla en blanco.
 */
import { useNavigate } from 'react-router-dom';
import { PageHeader } from '../components/PageHeader';
import { EmptyState } from '../components/EmptyState';

export function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <section>
      <PageHeader title="Página no encontrada" subtitle="Esta ruta no existe en NAAR Real State." />
      <EmptyState
        icon="home"
        title="No hemos encontrado esta pantalla"
        body="Puede que el enlace esté mal o que la pantalla se haya movido. Vuelve al panel de inicio para seguir."
        actionLabel="Ir al inicio"
        onAction={() => navigate('/')}
      />
    </section>
  );
}
